export enum STORAGE_KEY {
  makeModel = 'UCD_MAKE_MODEL',
  toolTipShown = 'UCD_TOOLTIP_SHOWN',
  selectedCity = 'UCD_SELECTED_CITY',
  nearbyDealers = 'UCD_NEARBY_DEALERS',
  popularBrands = 'UCD_POPULAR_BRANDS',
  minPrice = 'UCD_MIN_PRICE',
  maxPrice = 'UCD_MAX_PRICE',
  sessionInitiator = 'UCD_INITIATOR',
}
